import {
    IonButton,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
} from "@ionic/react"
import { addOutline } from "ionicons/icons"

import { AddUserSearchBar } from "./AddUserSearchBar"
import { selectUsersAvailable } from "../../../store/profileDetail/selector/selectUsersAvailable"
import { useDispatch, useSelector } from "react-redux"
import { setPreselectUser } from "../../../store/profileDetail/profileDetail.reducer"


export const AddUserSelector = () => {
    const dispatch = useDispatch();
    const users = useSelector(selectUsersAvailable);

    return (
        <IonContent>
        <AddUserSearchBar />
            <IonContent style={{ overflow: "scroll"}}>
                <IonListHeader>
                    {users.length > 0
                        ? `${users.length} usuarios disponibles para agregar:`
                        : "No hay usuarios disponibles para agregar."}
                </IonListHeader>
                <IonList style={{ overflow: "auto" }}>
                    {users.map((user) => (
                            <IonItem key={user.id}>
                                <IonLabel>{user.name}</IonLabel>
                                <IonButton onClick={() => dispatch(setPreselectUser(user))}>
                                    <IonIcon icon={addOutline} />
                                </IonButton>
                            </IonItem>
                        ))}
                </IonList>
            </IonContent>
        </IonContent>
    )
}